import { getAllRooms } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import FilterIcon from '@shared/icons/FilterIcon';
import { Divider } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PopoverCombobox from '@shared/Reports/PopoverCombobox';
import PopoverDateRange from '@shared/Reports/PopoverDateRange';
import PopoverSelect from '@shared/Reports/PopoverSelect';
import { getExistingParents } from '@/app/services/students/students';

const SubscriptionFiltersBar = ({ filters, setFilters }) => {
	const [rooms, setRooms] = useState([]);
	const [roomsLoading, setRoomsLoading] = useState(true);
	const [parents, setParents] = useState([]);
	const [parentsLoading, setParentsLoading] = useState(false);
	const dispatch = useDispatch();
	const [searchTimeout, setSearchTimeout] = useState(null);

	useEffect(() => {
		const fetchRooms = async () => {
			try {
				setRoomsLoading(true);
				const res = await getAllRooms();
				setRooms(res.data);
				setRoomsLoading(false);
			} catch (error) {
				dispatch(
					Actions.showMessage({
						title: 'Error',
						message: 'Failed to fetch rooms',
						variant: 'error',
					})
				);
				setRoomsLoading(false);
			}
		};
		fetchRooms();
	}, []);

	const handleSearchParents = async (searchTerm) => {
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const timeoutId = setTimeout(async () => {
			setParentsLoading(true);
			try {
				const res = await getExistingParents(searchTerm);
				setParents(res.data.data.map((parent) => ({ label: parent.name, value: parent.id })));
			} catch (error) {
				console.error('Failed to fetch parents', error);
			}
			setParentsLoading(false);
		}, 300);

		setSearchTimeout(timeoutId);
	};

	return (
		<div
			className="text-white py-16 px-16 md:px-32 justify-between flex flex-wrap"
			style={{ background: 'rgb(0, 46,108)' }}
		>
			<div className="flex items-center gap-8 text-16">
				<FilterIcon /> <span>Filter:</span>
			</div>
			<div className="flex gap-8 md:gap-16 flex-wrap">
				<PopoverDateRange filters={filters} setFilters={setFilters} />
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverCombobox
					currentFilter="room_id"
					filters={filters}
					loading={roomsLoading}
					options={
						roomsLoading
							? []
							: rooms?.map((room) => {
									return { label: room?.name, value: room?.id };
								})
					}
					setFilter={setFilters}
					title="Room"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverCombobox
					currentFilter="parent_id"
					filters={filters}
					loading={parentsLoading}
					onSearch={handleSearchParents}
					options={parents}
					setFilter={setFilters}
					title="Parent Name"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverSelect
					currentFilter="search_type"
					filters={filters}
					options={[
						{ label: 'Active Subscriptions', value: 'active' },
						{ label: 'Renewal Date', value: 'renews' },
						{ label: 'Subscribed Since', value: 'since' },
						{ label: 'Never Installed', value: 'no_app' },
					]}
					setFilter={setFilters}
					title="Filter By"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverSelect
					currentFilter="package_type"
					filters={filters}
					options={[
						{ label: 'Included', value: 1 },
						{ label: 'Premium', value: 2 },
						{ label: 'Ultimate', value: 3 },
					]}
					setFilter={setFilters}
					title="Plan Type"
				/>
			</div>
		</div>
	);
};

export default SubscriptionFiltersBar;
